function isNotNil(x) {
    return x != null;
}

export { isNotNil };
